/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoVkIcon20Solid = forwardRef('LogoVkIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10.652 15.591c-6.113 0-9.6-4.197-9.745-11.182h3.062c.1 5.126 2.305 7.298 4.093 7.746V4.409h2.91V8.83c1.765-.19 3.647-2.205 4.273-4.421h2.883c-.48 2.731-2.492 4.746-3.922 5.574 1.43.672 3.721 2.43 4.593 5.608h-3.174c-.682-2.127-2.408-3.772-4.654-3.996v3.996h-.32Z" })));
});
